/**
 * LWcustom - Modify this array to include any models that have special display names
 */
export const customTitles = [
  {
    original: "template_custom_title",
    display: "Template Custom Title",
  },
  {
    original: "featurenodes",
    display: "Feature Nodes",
  },
  {
    original: "tags",
    display: "Filters",
  },
  {
    original: "abouts",
    display: "About",
  },
  {
    original: "welcomepopup",
    display: "Welcome Popup",
  },
];

export interface IDropdownOption {
  label?: string;
  value: string | number;
}

export interface IDropdownMapping {
  model: string;
  field: string;
  options: IDropdownOption[];
}

/**
 * Custom dropdown options. Forms will intercept these models and fields to add dropdown options to them
 */
export const dropdownFields = [
  {
    model: "featurenodes",
    field: "nodetype",
    options: [
      { label: "Feature", value: "feature" },
      { label: "Video", value: "video" },
    ],
  },
  {
    model: "mediaitems",
    field: "type",
    options: [
      { label: "Image", value: "image" },
      { label: "Video", value: "video" },
    ],
  },
  {
    model: "users",
    field: "user_role",
    options: [
      { label: "Admin", value: "admin" },
      { label: "User", value: "user" },
    ],
  },
];

interface ICustomField {
  original: string;
  display?: string;
  hint?: string;
  optional?: boolean;
  accept?: string;
  modelSpecific?: ICustomFieldModelSpecific[];
  hide?: boolean;
}

interface ICustomFieldModelSpecific {
  modelName: string;
  display?: string;
  hint?: string;
  accept?: string;
  optional?: boolean;
  hide?: boolean;
}

/**
 * LWcustom - Modify this array to include model fields that have custom display names and hints on their forms
 */
export const customFieldNames: ICustomField[] = [
  {
    original: "template_custom_item",
    display: "Template Custom Item",
    hint: "Hints for fields",
    modelSpecific: [
      {
        modelName: "model_name",
        display: "This model's field will be displayed as this name",
        hint: "This model will get this hint",
      },
    ],
  },
  {
    original: "mfa_enabled",
    display: "Enable MFA",
  },
];
